"use client";
import * as React from "react";
const SvgCheckFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m5.09 9.62-3.8-3.79L0 7.11l5.09 5.09L16 1.28 14.72 0z" }));
export {
  SvgCheckFilled as default
};
